import React, { useState, useEffect, useRef } from 'react';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { ListItemButton } from '@mui/material';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Stack } from '@mui/material';
import CampaignIcon from '@mui/icons-material/Campaign';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import ScheduleList from './ScheduleList';
import EditOffice from './EditOffice';
import StorefrontIcon from '@mui/icons-material/Storefront';
import OfficeTodaysSchedule from './OfficeTodaysSchedule';
import { formatTime } from '../helpers/Helpers';
import ContactList from './ContactList';
import AppointmentCodeOptions from './AppointmentCodeOptions';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import { isMobile } from 'react-device-detect';
import SwipeableEdgeDrawer from './SwipeableEdgeDrawer';
import SchedulesCalendar from './ScheduleCalendar';
import OfficeTodaysFixedSchedule from './OfficeTodaysFixedSchedule';
import OfficePosts from './OfficePosts';
import { formatDateTime } from '../helpers/Helpers';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import { truncateString } from '../helpers/Helpers';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(1),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
}));  

function OfficesListItem(props) {

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = (event, reason) => {
        if (reason === 'clickaway' || reason === 'backdropClick') {
            return;
        }
        setOpen(false);
        props.fetchOffices();
    };

    useEffect(() => {
        if (props.office.todays_schedule)
        {
            setExpand(false);
        }
        else {
            setExpand(true);
        }
    }, []);

    const [expand, setExpand] = useState(false);

    const toggleExpand = () => {
        if (expand === false)
        {
            setExpand(true);
        }
        else {
            setExpand(false);
        }
        
    };

    const getOfficeServingDisplay = (schedule) => {
        const { end_reached, now_serving, now_serving_name } = schedule;

        if (!now_serving || !now_serving_name) {
            return "...";
        }

        return end_reached ? "..." : now_serving;
    }

    const containerRef = React.useRef(null);
 
    return (
        <React.Fragment>
            <ListItemButton onClick={handleClickOpen} alignItems={props.office.todays_schedule ? "flex-start" : "center"}>
                <ListItemAvatar>
                    <Avatar style={{ background: '#86BBD8' }}>
                        <StorefrontIcon />
                    </Avatar>  
                </ListItemAvatar>
                <ListItemText style={{whiteSpace: "pre-line", verticalAlign: "bottom"}}
                    primary={props.office.name}
                    secondary={ 
                        props.office.todays_schedule && props.office.todays_schedule.type == 1
                        ? <React.Fragment>
                            <Typography
                                sx={{ display: 'inline' }}
                                component="span"
                                variant="body2"
                                color="text.primary"
                                alignItems='center'
                            >
                            <>
                            {props.office.todays_schedule.now_serving > 0 && (
                                <>
                                Now serving: <b>{getOfficeServingDisplay(props.office.todays_schedule)}</b> |{" "}
                                </>
                            )}
                            In queue: <b>{props.office.todays_schedule.num_waiting}</b>
                            </>
                            </Typography>
                        </React.Fragment>
                        : props.office.todays_schedule && props.office.todays_schedule.type == 2
                        ? <React.Fragment>
                            <Typography
                                sx={{ display: 'inline' }}
                                component="span"
                                variant="body2"
                                color="text.primary"
                                alignItems='center'
                            >
                            <>
                            Guests arriving: <b>{props.office.todays_schedule.guests_arriving}</b>
                            </>
                            </Typography>
                        </React.Fragment>
                        :
                        null
                    }
                >
                </ListItemText>
            </ListItemButton>
            <Divider variant="middle" component="li" />


            <BootstrapDialog
                fullScreen={isMobile}
                ref={containerRef}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                PaperProps={{
                    sx: {
                    mt: '58px', // margin-top of 40px
                    height: 'calc(100% - 58px)', // reduce height to preserve spacing
                    },
                }}

            >
                <DialogTitle sx={{ m: 2, p: 0 }} id="customized-dialog-title">
                    <Box display="flex" alignItems="center" sx={{ lineHeight: 1.2, gap: 1 }}> 
                        <ArrowBackIcon onClick={handleClose} /> {props.office.name}
                    </Box>

                    <Typography
                    style={{ whiteSpace: "pre-line", verticalAlign: "bottom" }}
                    sx={{ lineHeight: 1.2, mt: 1 }} // adds spacing above
                    component="div"
                    >
                    {/* <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={0} padding={1}>
                        <AccessTimeFilledIcon />
                        Opens {formatTime(props.office.default_start_time)}<br />
                        Closes {formatTime(props.office.default_end_time)}
                    </Stack> */}
                    </Typography>
                    
                        {props.office.notes ?
                        <Stack
                        direction="row"
                        alignItems="flex-start"
                        spacing={1} // space between icon and text
                        padding={1}
                        >
                        {/* Left column: Icon */}
                        <StickyNote2Icon sx={{ color: 'gray' }} />

                        {/* Right column: Text stacked vertically */}
                            <Stack direction="column" spacing={0}>
                                <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 13 }}>
                                    Status
                                </Typography>
                                <Typography
                                style={{ whiteSpace: "pre-line", verticalAlign: "bottom" }}
                                sx={{ lineHeight: 1.2 }}
                                component="div"
                                >
                                    {truncateString(props.office.notes, 100)}
                                </Typography>
                            </Stack>
                        </Stack>
                        : null }
                    
                        {props.office.latest_post ?
                        <Stack
                        direction="row"
                        alignItems="flex-start"
                        spacing={1} // space between icon and text
                        padding={1}
                        >
                        {/* Left column: Icon */}
                        <CampaignIcon sx={{ color: 'gray' }} />

                        {/* Right column: Text stacked vertically */}
                            <Stack direction="column" spacing={0}>
                                <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 13 }}>
                                    Latest Advisory<br />
                                    {formatDateTime(props.office.latest_post_date)}
                                </Typography>
                                <Typography
                                style={{ whiteSpace: "pre-line", verticalAlign: "bottom" }}
                                sx={{ lineHeight: 1.2 }}
                                component="div"
                                >
                                    {truncateString(props.office.latest_post, 100)}
                                </Typography>
                            </Stack>
                        </Stack>
                        : null }
                    
                    <Stack justifyContent="center" direction="row" spacing={3}>
                        <SchedulesCalendar setRecentAppLinkGenerate={props.setRecentAppLinkGenerate} fetchOffices={props.fetchOffices} officeId={props.office.id} officeName={props.office.name}/>
                        <OfficePosts officeId={props.office.id} officeName={props.office.name} fetchOffices={props.fetchOffices} />
                        <ContactList officeId={props.office.id} officeName={props.office.name}/>
                        <EditOffice officeNotes={props.office.notes} officeMinutes={props.office.default_average_serve_minutes} startTime={props.office.default_start_time} endTime={props.office.default_end_time} fetchOffices={props.fetchOffices} officeId={props.office.id} />
                    </Stack>
                    
                </DialogTitle>

                <DialogContent dividers={props.office.todays_schedule ? true : false}>
                    {isMobile && props.office.todays_schedule ?
                        <SwipeableEdgeDrawer containerRef={containerRef} setRecentAppLinkGenerate={props.setRecentAppLinkGenerate} fetchOffices={props.fetchOffices} office={props.office} officeId={props.office.id} officeName={props.office.name} schedule={props.office.todays_schedule} />
                    : null}
                    { !isMobile && props.office.todays_schedule 
                        ? props.office.todays_schedule.type == 1  
                            ? <OfficeTodaysSchedule setRecentAppLinkGenerate={props.setRecentAppLinkGenerate} fetchOffices={props.fetchOffices}  officeId={props.office.id} officeName={props.office.name} schedule={props.office.todays_schedule} /> 
                            : <OfficeTodaysFixedSchedule setRecentAppLinkGenerate={props.setRecentAppLinkGenerate} fetchOffices={props.fetchOffices}  officeId={props.office.id} officeName={props.office.name} schedule={props.office.todays_schedule} />
                    : null }
                </DialogContent>
            </BootstrapDialog>
        </React.Fragment>
      );
}

export default OfficesListItem;